var Homepage = new (class Homepage extends AbstractModule {
  /**
   * Homepage module constructor
   * Prepares empty object for old cards handling - Deprecation coming soon
   */
  constructor () {
    super("Homepage")

    this.cards = {}
    this.userInfos = null
    this._skipToConversationsOnly = false
  }

  /**
   * Post widget initialization hook
   * Updating Conversation view soapy status
   */
  _initAfterWidget () {
    if (this.app._reply_mode == 'personalized' && this.app._display_members) {
      Conversations.subscribeSummaryList("slaask-widget-homepage-conversations-users", "slaask-conversation-homepage-", 3, true, true)
    }

    let conversationsView = Views.getByName('conversations')
    conversationsView.on('soapy-changed', soapy => {
      if (soapy)
        Dom.addClass('widget', '#slaask-widget-homepage-conv-button2', 'slaask-hidden')
      else
        Dom.removeClass('widget', '#slaask-widget-homepage-conv-button2', 'slaask-hidden')
    })
  }

  /**
   * todo: _initAfterGuest description
   * @param {Object} guestData
   */
  _initAfterGuest (guestData) {
    this.userInfos = guestData.user_infos

    this.cards = {
      conversations: true,
      hc: this.app._hc_enabled,
      meetings: Meetings.enabled,
      newsletter: this.app._newsletter_enabled,
      phone: this.app._phone_enabled,
      status: this.app._status_enabled,
      customs: this.app._old_custom_cards && this.app._old_custom_cards.length
    }
    let enabledCount = 0

    for (let id in this.cards) {
      if (this.cards[id])
        enabledCount++
    }

    if (this._shouldSkipHomepage(enabledCount)) {
      this._skipToConversationsOnly = true
      Views.getByName('homepage').soapy = true
    }
  }

  skipsToConversationsOnly () {
    return this._skipToConversationsOnly
  }

  _visibleCustomCards () {
    return this.app._custom_cards.filter(card => {
      return this.app._homepage_global_scope === true
        || card.widgets_custom_card.scope === 'global'
        || card.widgets_custom_card.scope === this.getUserKind()
    })
  }

  _onlyConversationsCardEnabled (enabledCount) {
    if (this.app._custom_cards.length > 0) {
      const visibleCards = this._visibleCustomCards()
      return visibleCards.length === 1 && visibleCards[0].label === 'conversations'
    }

    return enabledCount === 1 && this.cards.conversations
  }

  _shouldSkipHomepage (enabledCount) {
    if (this.app._homepage_disabled) return true
    if (this.app._custom_cards.length === 0 && enabledCount === 0) return true

    return this._onlyConversationsCardEnabled(enabledCount)
  }

  /**
   * todo: _initFaqForm description
   */
  _initFaqForm () {
    let helpcenterFrom = Dom.findById('widget', 'slaask-widget-homepage-helpcenter-form')
    if (helpcenterFrom) {
      helpcenterFrom.addEventListener("submit", async (event) => {
        event.preventDefault()

        var query = Dom.findById('widget', 'slaask-widget-homepage-helpcenter-input').value
        if(query != '') {
          Dom.addClass('widget', '#slaask-widget-homepage-submit-image', 'slaask-hidden')
          Dom.removeClass('widget', '#slaask-homepage-helpcenter-loader', 'slaask-hidden')

          let availableFaqs = await Faqs.fetchFaqsQuery(query, false, true)

          var faqContainer  = Dom.findById('widget', 'slaask-widget-homepage-helpcenter-content')
          var cardContainer = Dom.findById('widget', 'slaask-widget-homepage-helpcenter')

          faqContainer.innerHTML = ''
          let button = Dom.findById('widget', 'slaask-widget-homepage-more-faq-button')
          if (button) {
            button.setAttribute('href', `${this.app._help_center_url}/hc/?q=${query}`)
            Utils.removeElement(button)
          }

          if (availableFaqs.length == 0) {
            faqContainer.innerHTML = '<p>' + Wording.homepage_helpcenter_no_results.replace('{{search}}', query).replace('""', '"' + query + '"') + '<br>' + Wording.homepage_no_results_try_again + '</p>'

            Dom.removeClass('widget', '#slaask-widget-homepage-submit-image', 'slaask-hidden')
            Dom.addClass('widget', '#slaask-homepage-helpcenter-loader', 'slaask-hidden')
          } else {
            faqContainer.innerHTML = '<p>' + Wording.homepage_helpcenter_results.replace('{{search}}', query).replace('""', '"' + query + '"') + '</p>'

            for (var i = 0; i < availableFaqs.length; i++) {
              let itemStyle
              if(i == 0) {
                itemStyle = ' style="border-top: 1px solid #e6ecf5;"'
              } else {
                itemStyle = ''
              }

              faqContainer.innerHTML = faqContainer.innerHTML + '<a id="homepage-faq-' + availableFaqs[i].objectID + '" data-url="' + availableFaqs[i].url + '" href="#" class="slaask-widget-homepage-helpcenter-item"' + itemStyle + '><div class="slaask-widget-homepage-helpcenter-item-title" style="color:' + this.app._window_color + '">' + availableFaqs[i].title + '</div><div class="slaask-widget-homepage-helpcenter-item-content" >' + availableFaqs[i].description + '</div></a>'
            }

            cardContainer.insertAdjacentHTML('beforeend', '<a href="' + this.app._help_center_url + '/hc/?q=' + encodeURIComponent(query) + '" target="_blank" class="slaask-widget-homepage-cta" id="slaask-widget-homepage-more-faq-button" style="background-color:#FFF;border:1px solid ' + this.app._window_color + '">' + Wording.homepage_helpcenter_more + '</a>')

            Dom.removeClass('widget', '#slaask-widget-homepage-submit-image', 'slaask-hidden')
            Dom.addClass('widget', '#slaask-homepage-helpcenter-loader', 'slaask-hidden')

            let faqElements = Dom.findAll('widget', '.slaask-widget-homepage-helpcenter-item')

            for (let i = 0; i <= faqElements.length - 1; i++) {
              faqElements[i].addEventListener("click", (e) => {
                e.preventDefault()
                Views.jumpToViewByName('iframe', Utils.dataSet(faqElements[i], 'url'))
              })
            }

            let homepageViewEl = Views.getByName('homepage').element
            homepageViewEl.scrollTo({
              top: Dom.findById('widget', 'slaask-widget-homepage-helpcenter').offsetTop
                    - parseInt(Dom.get('widget').window.getComputedStyle(homepageViewEl)['padding-left']),
              left: 0,
              behavior: 'smooth'
            })
          }
        }
      })
    }
  }

  /**
   * todo: _initSubscribeForm description
   */
  _initSubscribeForm () {
    let form = Dom.findById('widget', 'slaask-widget-homepage-newsletter-form')
    if (form) {
      form.addEventListener("submit", async (event) => {
        event.preventDefault()

        var email = Dom.findById('widget', 'slaask-widget-homepage-newsletter-input').value

        if(/^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
          Dom.addClass('widget', '#slaask-widget-homepage-submit-newsletter-image', 'slaask-hidden')
          Dom.removeClass('widget', '#slaask-homepage-newsletter-loader', 'slaask-hidden')

          await Ajax.call('/api/add_to_newsletter', { key: this.app._api_key, token: this.app._guest_token, email: email })

          Dom.findById('widget', 'slaask-widget-homepage-newsletter-content').innerHTML =  "<p>" + Wording.homepage_newsletter_success + email + "</p>"
          Dom.findById('widget', 'slaask-widget-homepage-newsletter-form').remove()
        } else {
          Dom.getById('widget', 'slaask-widget-homepage-newsletter-content').innerHTML =  '<p class="newsletter-fail">' + Wording.homepage_newsletter_fail + '</p>'
        }
      })
    }
  }

  /**
   * Returns widget identified guest kind (either 'lead' or 'known')
   * @returns {String}
   */
  getUserKind () {
    if (this.userInfos === null || this.userInfos.more === null || this.userInfos.more.kind === null) {
      return ('lead')
    }

    return (this.userInfos.more.kind === 'user' ? 'known' : 'lead')
  }

  /**
   * todo: createCustomBlocks description
   * @param {Object} blocks
   * @param {Boolean} withFilters
   * @returns {String}
   */
  createCustomBlocks (blocks, withFilters = false) {
    let blockContent = []

    if (!withFilters || this._shouldDisplayBlock(blocks[0])) {
      for (var customBlockIterator = 0; customBlockIterator < blocks.length; customBlockIterator++) {
        let block   = blocks[customBlockIterator]

        switch (block.type) {
          case 'text':
            blockContent.push(this._getTextBlock(block))
            break
          case 'image':
            blockContent.push(this._getImageBlock(block))
            break
          case 'divider':
            blockContent.push('<hr>')
            break
          case 'list':
            blockContent.push(this._getListBlock(block))
            break
          case 'input':
            break
          case 'button':
            blockContent.push(this._getButtonBlock(block))
            break
          case 'iframe':
            blockContent.push(this._getIframeBlock(block))
            break
        }
      }
    }

    if (blockContent.length == 0) {
      return ''
    } else {
      return `
        <style>.slaask-widget-homepage-custom-card .slaask-widget-homepage-cta,.slaask-widget-homepage-card .slaask-widget-homepage-cta { background-color: ${this.app._window_color}!important;color: ${this.app._title_color} } .slaask-widget-homepage-custom-card .slaask-widget-homepage-cta2,.slaask-widget-homepage-card .slaask-widget-homepage-cta2 { color: ${this.app._window_color}!important }</style>
        <div class="slaask-widget-homepage-card slaask-widget-card slaask-widget-homepage-custom-card">
          ${blockContent.join('')}
        </div>`
    }
  }

  /**
   * todo: _shouldDisplayBlock description
   * @param {Object} block
   * @returns {Boolean}
   */
  _shouldDisplayBlock (block) {
    if (block.condition && block.condition != 'all') {
      return Utils.deepGet(this.app, ['_user_infos', 'more', 'kind']) == block.condition
    } else {
      return true
    }
  }

  /**
   * todo: _getTextBlock description
   * @param {Object} block
   * @returns {String}
   */
  _getTextBlock (block) {
    if (block.format != 'html') {
      block.content = this.app._askTechParser.mdToHtml(block.content)
    }

    return `
      <div class="slaask-widget-homepage-card-style-${block.style || 'default'}" style="text-align: ${block.align || 'left'}">
        ${block.content}
      </div>`
  }

  /**
   * todo: _getImageBlock description
   * @param {Object} block
   * @returns {String}
   */
  _getImageBlock (block) {
    return `<img src="${block.url}">`
  }

  /**
   * todo: _getListBlock description
   * @param {Object} block
   * @returns {String}
   */
  _getListBlock (block) {
    let listContent = []

    for (var i = 0; i < block.items.length; i++) {
      let item            = block.items[i]
      let itemContent     = `<p class="slaask-widget-homepage-card-list-item-title">${item.title}<p>`
      let blockElement    = 'div class="'
      let blockEndElement = 'div'

      if (item.subtitle) {
        if (item.subtitle.length > 84) {
          item.subtitle = `${item.subtitle.substring(0, 84)}...`
        }
        itemContent += `<p class="slaask-widget-homepage-card-list-item-subtitle">${item.subtitle}<p>`
      }

      if (item.image && item.image.url != '') {
        itemContent = `
          <div class="slaask-widget-homepage-card-list-item-part slaask-widget-homepage-card-list-item-image">
            <img src="${item.image.url}" class="${item.image.rounded == true || item.image.rounded == 'true' ? 'slaask-widget-homepage-card-image-rounded' : ''}">
          </div>
          <div class="slaask-widget-homepage-card-list-item-part">
            ${itemContent}
          </div>`
      } else {
        itemContent = `<div class="slaask-widget-homepage-card-list-item-part">${itemContent}</div>`
      }

      if (item.action) {
        if (item.action.type == 'url' && item.action.url && item.action.url != '') {
          blockElement    = `a target="_blank" href="${item.action.url}" class="slaask-widget-homepage-card-link `
          blockEndElement = 'a'
        }
        if (item.action.type == 'js' && item.action.function && item.action.function != '') {
          blockElement    = `a href="#" onclick="event.preventDefault(); ${item.action.function.replace('()', '')}(); return false;" class="slaask-widget-homepage-card-link `
          blockEndElement = 'a'
        }
      }

      listContent.push(`
        <${blockElement}slaask-widget-homepage-card-list-item${item.image ? ' slaask-widget-homepage-card-list-item-with-image' : ''}">
          ${itemContent}
        </${blockEndElement}>`)
    }

    return `
      <div class="slaask-widget-homepage-card-list">
        ${listContent.join('')}
      </div>`
  }

  /**
   * todo: _getButtonBlock description
   * @param {Object} block
   * @returns {String}
   */
  _getButtonBlock (block) {
    if (block.action.type == 'url' && block.action.url && block.action.url != '') {
      return `<a target="_blank" href="${block.action.url}" class="slaask-widget-homepage-cta${block.style == 'secondary' ? 2 : ''}">${block.content}</a>`
    }
    if (block.action.type == 'js' && block.action.function && block.action.function != '') {
      return `<a target="_blank" onclick="event.preventDefault(); _${this.app._guessBrand()}.parentWindow().${block.action.function.replace('()', '').replace('"', "'")}(); return false;" href="#" class="slaask-widget-homepage-cta${block.style == 'secondary' ? 2 : ''}">${block.content}</a>`
    }
  }

  /**
   * todo: _getIframeBlock description
   * @param {Object} block
   * @returns {String}
   */
  _getIframeBlock(block) {
    let maxWidth = block.style == 'fullwidth' ? 334 : 286

    if (block.content.match(/<iframe/) || block.content.match(/<stream/)) {
      if (block.content.match(/width="(\d+)(px)?"/)) {
        let currentWidth  = parseInt(block.content.match(/width="(\d+)(px)?"/)[1])
        let currentHeight = parseInt(block.content.match(/height="(\d+)(px)?"/)[1])
        let multiplicator = maxWidth / currentWidth
        let newHeight     = Math.round(currentHeight * multiplicator)

        block.content = block.content.replace(`width="${currentWidth}px"`, `width="${maxWidth}px"`)
        block.content = block.content.replace(`width="${currentWidth}"`, `width="${maxWidth}"`)
        block.content = block.content.replace(`height="${currentHeight}px"`, `height="${newHeight}px"`)
        block.content = block.content.replace(`height="${currentHeight}"`, `height="${newHeight}"`)

        if (block.content.match(/style="/)) {
          if (block.content.match(/width:( ?\S+?);/)) {
            block.content = block.content.replace(/width:( ?\S+?);/, `width:${maxWidth}px;`)
          } else {
            block.content = block.content.replace(`style="`, `style="width:${maxWidth}px;`)
          }
          if (block.content.match(/height:( ?\S+?);/)) {
            block.content = block.content.replace(/height:( ?\S+?);/, `height:${newHeight}px;`)
          } else {
            block.content = block.content.replace(`style="`, `style="height:${newHeight}px;`)
          }
        } else {
          block.content = block.content.replace(`<iframe `, `<iframe style="width: ${maxWidth}px;height: ${newHeight}px;" `)
        }
      }
    }

    return `<div class="card-iframe-container${block.style == 'fullwidth' ? ' card-iframe-fullwidth-container' : ''}"><iframe class="load-in-iframe">${block.content}</iframe></div>`
  }
})
